// Formats a Brazilian phone number for display as the user types: 8-digit landlines get
// "+55 (XX) XXXX-XXXX", 9-digit mobiles get "+55 (XX) XXXXX-XXXX". Tolerates a leading "55"
// (e.g. pasted from WhatsApp) without double-prefixing it.
export const formatBrazilPhone = (input = '') => {
  let digits = String(input).replace(/\D/g, '');

  if (digits.startsWith('55') && digits.length > 11) {
    digits = digits.slice(2);
  }
  digits = digits.slice(0, 11);

  if (!digits) return '';

  const ddd = digits.slice(0, 2);
  if (digits.length <= 2) {
    return `+55 (${ddd}`;
  }
  if (digits.length <= 6) {
    return `+55 (${ddd}) ${digits.slice(2)}`;
  }
  if (digits.length <= 10) {
    return `+55 (${ddd}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `+55 (${ddd}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

// Extracts the E.164 phone number (+55DDDNNNNNNNNN) the backend expects. Returns null when
// there aren't enough digits for a valid DDD + number (10 or 11 digits total).
export const extractBrazilPhoneE164 = (input = '') => {
  let digits = String(input).replace(/\D/g, '');
  if (digits.startsWith('55') && digits.length > 11) {
    digits = digits.slice(2);
  }
  digits = digits.slice(0, 11);

  if (digits.length < 10) return null;

  return `+55${digits}`;
};
